import styled from 'styled-components';

export const Section01_Styled = styled.section`
  position: relative;
  padding: 56px 0 80px;
  background-color: #ffffff;

  @media screen and (min-width: 992px) {
    padding: 120px 0;
  }
`;

export const Title = styled.div`
  margin: 0 0 20px;

  @media screen and (min-width: 992px) {
    margin: 0 0 60px;
    grid-column: 3 / 11;
  }

  h2 {
    margin: 0 0 20px;
    font-size: 12px;
    font-weight: 600;
    -webkit-letter-spacing: 1px;
    -moz-letter-spacing: 1px;
    -ms-letter-spacing: 1px;
    letter-spacing: 1px;
    line-height: 1.7;
    text-transform: uppercase;
    color: #eb5424;
    text-align: center;

    @media screen and (min-width: 992px) {
      margin: 0 0 40px;
      font-size: 14px;
    }
  }

  h1 {
    font-size: 20px;
    line-height: 1.3;
    font-weight: 500;
    color: #333333;
    text-align: center;

    @media screen and (min-width: 992px) {
      font-size: 32px;
    }
  }
`;

export const HighLightText = styled.div`
  font-size: 16px;
  line-height: 28px;
  text-align: center;
  align-self: start;
  color: #4f4f4f;

  @media screen and (min-width: 992px) {
    grid-column: 2 / 6;
    margin-bottom: 0;
    font-size: 18px;
    line-height: 30px;
    text-align: left;
  }
`;

export const Nav = styled.ul`
  padding-left: 16px;
  margin: 0;
  font-size: 16px;
  line-height: 27.2px;
  list-style: none;
  color: #727272;

  @media screen and (min-width: 992px) {
    grid-column: 8 / 12;
  }

  li {
    position: relative;
    padding-left: 20px;
    margin-bottom: 32px;

    &:before {
      content: '';
      position: absolute;
      top: 12px;
      left: 0;
      width: 6px;
      height: 6px;
      background-color: #000000;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const Scheme = styled.div`
  max-width: 960px;
  width: 98%;
  margin: -115px auto 0;
  position: relative;
  height: 630px;

  @media screen and (min-width: 480px) {
    height: 610px;
  }

  @media screen and (min-width: 992px) {
    height: 770px;
  }

  .slick-nav {
    margin: 365px 0 0 0;
    transform: translateX(-50%);
    width: 90%;
    position: absolute;
    left: 50%;
    top: 0;
    font-family: fakt-web, Helvetica Neue, Hevetica, sans-serif;
    z-index: 10;

    @media screen and (min-width: 480px) {
      margin: 440px 0 0 0;
    }

    @media screen and (min-width: 992px) {
      margin: 0 0 0 105px;
      transform: none;
      width: auto;
    }

    div {
      &:focus {
        outline: none;
      }
    }

    .slick-list {
      width: auto;

      @media screen and (min-width: 992px) {
        width: 380px;
      }
    }

    .slick-slide {
      width: 100% !important;
      display: block;
      padding: 25px 0 0 35px;
      border-bottom: none;
      color: rgba(0, 0, 0, 0.2);
      transition: color 0.3s ease-in-out;
      cursor: pointer;
      font-size: 16px;
      line-height: 28px;
      position: relative;

      @media screen and (min-width: 992px) {
        padding: 25px 0 25px 35px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        width: 380px !important;
      }

      &:before {
        display: inline-block;
        position: absolute;
        left: 0;
        top: 25px;
      }

      &.slick-current {
        color: rgba(0, 0, 0, 0.65);
      }

      &:nth-child(1) {
        &:before {
          content: '1';
        }
      }

      &:nth-child(2) {
        &:before {
          content: '2';
        }
      }

      &:nth-child(3) {
        &:before {
          content: '3';
        }
      }

      &:last-child {
        border-bottom: none;
      }
    }
  }

  .slick-main {
    position: absolute;
    text-align: center;
    width: 100%;
    left: 0;
    top: 160px;

    @media screen and (min-width: 992px) {
      max-width: 960px;
    }

    .slick-dots {
      bottom: -35px;
    }

    .slick-slide {
      vertical-align: text-top;
      max-width: 960px;

      @media screen and (min-width: 992px) {
      }
    }

    video {
      width: 100%;
      display: none;

      @media screen and (min-width: 992px) {
        display: block;
      }
    }

    img {
      display: block;
      margin: 0 auto;
      max-width: 280px;
      width: 90%;

      @media screen and (min-width: 480px) {
        max-width: 390px;

        &.horizontal {
          margin-top: 75px;
        }
      }

      @media screen and (min-width: 992px) {
        display: none;
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/machine-to-machine/components/Section-01/styled.js